export type ValidationResult = {
	isValid: boolean;
	error?: string;
};

export const validResult: ValidationResult = {
	isValid: true
};

export const invalidResult = (error: string): ValidationResult => ({
	isValid: false,
	error
});
